"use strict";
import _ from 'lodash';
import cached from '../../../../../cachedData/stoppageStatuses';

function getInitialState () {
	return _.keyBy(cached.collections.stoppageStatusCollection.list, 'stoppageStatusId');
}

export default {getInitialState};

